// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"b80ed1f3808af5dd1f81","453":"e2c821d7b79172d61291","522":"c6bc7694c5684f63e96d"}[chunkId] + ".js";
};